<template>
    <v-container>

        <v-card-title>
            <h1>Parliamentary Handbook Help</h1>
        </v-card-title>
                
        <v-layout row wrap>
            <v-flex md2>
                <v-card-title>
                    <div id="side-help">
                        <ol>
                            <li v-for="item in tableOfContents" :key="item.id">
                                <a @click="jumpTo(item.id)">{{ item.text }}</a>
                            </li>
                        </ol>
                    </div>
                </v-card-title>                
            </v-flex>
            <v-flex md10>
                <v-card>
                    <v-card-title>
                        <div v-html="HELP_CONTENT" id="help"/>
                    </v-card-title>                                    
                </v-card>
            </v-flex>
        </v-layout>                
    </v-container>
</template>

<script>
    import axios from 'axios';
    import API from '@/mixins/HandbookAPI'

    export default {

        components: {
        },

        props: {

        },

        data() {
            return {
                HELP_LOADING: true,
                tableOfContents: [],
                HELP_CONTENT: '<div class="loader"></div>',
                HELP_ERROR: `<span style="color:red;font-weight:bold;font-size:12pt;">ERROR: Could not retrieve help content. Please try the <a href="${API.AphUrl}/help/Parliamentary_Handbook_Help">Parliamentary Handbook Help</a> on the APH Website.</span>`
            }
        },
        methods: {
            jumpTo(target) {
                const heading = document.querySelector('#' + target);
                const topPos = heading.getBoundingClientRect().top + window.pageYOffset - 85; //85 for height of app bar
                window.scrollTo({
                    top: topPos,
                    behavior: 'smooth'
                })
            }            
        },
        created() {
            axios.get(this.$store.state.API_HELP)
                .then((response) => {
                    this.HELP_LOADING = false;
                    if (response.status === 200) {
                        this.HELP_CONTENT = response.data;
                        window.setTimeout(() => {
                            
                            this.tableOfContents = Array.from(document.getElementById('help').getElementsByTagName('h2')).map(h => ({ text: h.innerText, id: h.id }));

                            if (window.location.hash) {
                                const heading = document.querySelector(window.location.hash);
                                const topPos = heading.getBoundingClientRect().top + window.pageYOffset - 85; //85 for height of app bar
                                window.scrollTo({
                                    top: topPos,
                                    behavior: 'smooth'
                                })
                            }
                        }, 200)

                    } else {
                        window.open(`${API.AphUrl}/help/Parliamentary_Handbook_Help`, '_blank')
                    }
                }).catch(() => {
                    this.HELP_LOADING = false;
                    this.HELP_CONTENT = this.HELP_ERROR;
                    window.open(`${API.AphUrl}/help/Parliamentary_Handbook_Help`, '_blank')
                });
        },
        computed: {
            HELP_LOADED: function () {
                return Boolean(!this.HELP_LOADING && this.HELP_CONTENT)
            }
        },
    }

</script>
<style>
</style>
